import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 24 25',
    fill: 'currentColor',
    defaultAriaLabel: 'Share Icon',
};

export const ShareIosCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M12.0127 0C12.2779 0.000319243 12.5322 0.105988 12.7195 0.29376L17.7075 5.294C18.0975 5.68501 18.0968 6.31817 17.7058 6.70822C17.3148 7.09826 16.6816 7.09749 16.2915 6.70649L12.9998 3.40667L12.9985 19.0003C12.9984 19.5526 12.5507 20.0002 11.9984 20.0002C11.4461 20.0001 10.9984 19.5524 10.9985 19.0001L10.9998 3.42189L7.70579 6.70818C7.31481 7.09825 6.68164 7.0975 6.29158 6.70652C5.90151 6.31554 5.90225 5.68238 6.29323 5.29231L11.2102 0.386842C11.3893 0.15665 11.6668 0.00680985 11.9795 0.000512433C11.9905 0.000158587 12.0016 -1.25491e-05 12.0127 0Z" />
            <path d="M22 12.0237C23.1046 12.0237 24 12.9191 24 14.0237V23.0002C24 24.1048 23.1046 25.0002 22 25.0002L2 25.0002C0.895431 25.0002 0 24.1048 0 23.0002V14.0002C0 12.8957 0.895432 12.0002 2 12.0002H6.5C7.05229 12.0002 7.5 12.448 7.5 13.0002C7.5 13.5525 7.05229 14.0002 6.5 14.0002H2L2 23.0002L22 23.0002V14.0237H17.5C16.9477 14.0237 16.5 13.576 16.5 13.0237C16.5 12.4714 16.9477 12.0237 17.5 12.0237H22Z" />
        </SvgIcon>
    );
};
